// const config = {
//   apiUrl: "https://quiz-app-7u8e.onrender.com/",
// };

const config = {
  apiUrl: "https://quiz-app-7u8e.onrender.com/",
};

export default config;
